import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/signature.scss";
import { CircularProgress } from "@mui/material";
import React from "react";

interface ButtonRoundedProps {
  onclick?: (e?: React.MouseEvent) => void;
  text: string;
  style?: string;
  loader?: boolean;
  parrentStyle?: string;
  arrow?: string;
  disabled?: boolean;
}

const ButtonRounded: React.FC<ButtonRoundedProps> = ({
  onclick,
  text,
  style,
  loader = false,
  parrentStyle,
  arrow = "",
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <Row
      className={`justify-content-center ${
        parrentStyle && parrentStyle
      } w-max m-0`}
    >
      <label
        htmlFor="files"
        onClick={!disabled ? onclick : undefined}
        className={` ${style} ${
          loader ? "loaderOpacity " : ""
        } ${disabled && !loader ? "disabledOpacity " : ""} py-1 upload_label m-0 ${!disabled ? "pointer" : ""} text_center text_15 productSansLight`}
      >
        {loader ? (
          <CircularProgress
            sx={{ width: "15px" }}
            className="themeColor mt-2"
          />
        ) : (
          t(text)
        )}
        {arrow ? <img className="mx-1 p-1" src={arrow} alt="arrow" /> : null}
      </label>
    </Row>
  );
};

export default ButtonRounded;
